
import axios from 'axios'

export default function createAxios (apiBase) {

 const resolvedBase = apiBase || process.env.VUE_APP_WEBAPI
  

  const instance =  axios.create({
    baseURL: apiBase || process.env.VUE_APP_WEBAPI, // central config
    timeout: 10000
    // you can add headers, interceptors etc.
  })

  // --- Request interceptor (logs every outgoing request)
  instance.interceptors.request.use(config => {
    console.log('[Axios Request]', config.method?.toUpperCase(), config.baseURL + config.url)
    return config
  }, error => {
    console.error('[Axios Request Error]', error.message)
    return Promise.reject(error)
  })

  // --- Response interceptor (logs data or error)
  instance.interceptors.response.use(response => {
    //console.log('[Axios Response]', response.status, response.data)
    return response
  }, error => {
    if (error.response) {
      console.error('[Axios Error Response]', error.response.status, error.response.data)
    } else {
      console.error('[Axios Error]', error.message)
    }
    return Promise.reject(error)
  })


  return instance
}